import React from 'react';
import styles from './Warning.module.css';

const Warning = ({ err }) => {
  return <div className={styles.container}>{err}</div>;
};

export default Warning;
